export default __webpack_public_path__ + "static/media/velo.f3db2241.png";